import React from "react";
import { Link } from "react-router-dom";
// nodejs library that concatenates strings
import classnames from "classnames";
// JavaScript plugin that hides or shows a component based on your scroll
import Headroom from "headroom.js";
// reactstrap components
import {
  Button,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  Nav,
  Container,
  UncontrolledTooltip,
} from "reactstrap";

// core components

function NavbarTop(props) {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [bodyClick, setBodyClick] = React.useState(false);
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [navLinkColor, setNavLinkColor] = React.useState("neutral");

  React.useEffect(() => {
    let headroom = new Headroom(document.getElementById("navbar-main"));
    // initialise
    headroom.init();
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 499 ||
        document.body.scrollTop > 499
      ) {
        setNavbarColor("");
        setNavLinkColor("link");
      } else if (
        document.documentElement.scrollTop < 500 ||
        document.body.scrollTop < 500
      ) {
        setNavbarColor("navbar-transparent");
        setNavLinkColor("neutral");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });

  return (
    <>
      {bodyClick ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setBodyClick(false);
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar
        className={classnames("fixed-top", navbarColor)}
        expand="lg"
        id="navbar-main">
        <Container>
          <div className="navbar-translate">
            <NavbarBrand
              id="navbar-brand"
              to="/"
              tag={Link}
              onClick={() => window.scrollTo(0, 0)}>
              {/*Jansvastha*/}
              <img
                src={require("../assets/img/partners/svastha.png").default}
                style={{ height: 35, width: 120 }}
              />
            </NavbarBrand>
            <UncontrolledTooltip placement="bottom" target="navbar-brand">
              Jansvastha
            </UncontrolledTooltip>
            <button
              className="navbar-toggler"
              id="navigation"
              type="button"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setBodyClick(true);
                setCollapseOpen(true);
              }}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
          </div>
          <Collapse navbar isOpen={collapseOpen}>
            <Nav className="ml-auto" navbar style={{alignItems: 'center'}}>
              <NavItem>
                <Button
                  className="btn-link"
                  color={navLinkColor}
                  href="/aboutus">
                  About us
                </Button>
              </NavItem>
              <NavItem>
                <Button
                  className="btn-link"
                  color={navLinkColor}
                  href="/covid19"
                >
                  COVID-19
                </Button>
              </NavItem>
              <NavItem>
                <Button
                  className="btn-link"
                  color={navLinkColor}
                  href="/twittersearch"
                >
                  Twitter Search
                </Button>
              </NavItem>
              <NavItem>
                <Button
                  className="btn-link"
                  color={navLinkColor}
                  href="/contact"
                >
                  Contact Us
                </Button>
              </NavItem>
              <NavItem>
                <Button className="btn-round" color="neutral" href={"tel:07314854004"}>
                  <img
                    src={require("../assets/img/partners/jansvastha.png").default}
                    style={{ height: 25, width: 150}}
                  />
                  <br/>
                    Helpline - 0731- 4854004
                </Button>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default NavbarTop;
